import { render, staticRenderFns } from "./EnergyConsumption.vue?vue&type=template&id=06c0d322&scoped=true&"
import script from "./EnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./EnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./EnergyConsumption.vue?vue&type=style&index=0&id=06c0d322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0d322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VProgressCircular})
